// ABOUTME: Captures ?ref=CODE from the URL, persists it across the visit, and
// ABOUTME: stamps every cart so paid orders carry the PEPTIKelite partner code.
//
// DATA FLOW:
// 1. On page load read `?ref=` (validated alphanumeric, ≤16 chars), persist to
//    localStorage + 30-day cookie under key `peptik_ref`.
// 2. On any add-to-cart click or `cart:update` event, sync the stored code into
//    the cart `attributes` via POST /cart/update.js so the resulting order's
//    `note_attributes` carries "Peptik Referral".
// 3. PEPTIKelite backend reads that attribute from the Shopify webhook payload
//    and credits the matching partner 20% (plus 10% override one level up).
//
// DEPENDENCIES:
// - Reads: localStorage, document.cookie, /cart.js
// - Writes: localStorage, document.cookie, /cart/update.js attributes
// - External: Shopify Ajax Cart API
(function () {
  if (window.__peptikRefBound) return;
  window.__peptikRefBound = true;

  var STORAGE_KEY = 'peptik_ref';
  var COOKIE_KEY = 'peptik_ref';
  var CART_ATTR_NAME = 'Peptik Referral';
  var COOKIE_TTL_DAYS = 30;
  // Accept Unicode letters (handles old all-caps + accented codes like
  // FRANÇOIS), digits, plus the `#` `_` `-` separators used by the new
  // `firstname#NNNN` generator. Cap at 32 chars so a malformed URL can't
  // stash an oversized blob in the cart attribute.
  var REF_PATTERN = /^[\p{L}\p{N}#_-]{1,32}$/u;

  function safeGetLocal(key) {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  }

  function safeSetLocal(key, value) {
    try { window.localStorage.setItem(key, value); } catch (_) { /* ignore */ }
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function normalizeRef(value) {
    if (typeof value !== 'string') return '';
    var trimmed = value.trim();
    if (!trimmed) return '';
    if (!REF_PATTERN.test(trimmed)) return '';
    // Preserve case — new codes are lowercase (`francois#8772`), legacy
    // codes are uppercase (`FRANÇOIS`, `RYAN10`). The webhook does a
    // case-insensitive lookup so either passes.
    return trimmed;
  }

  function readStoredRef() {
    // Une visite anterieure a pu figer une valeur polluee : on la purge au chargement.
    var pollue = normalizeRef(readCookie(COOKIE_KEY)) || normalizeRef(safeGetLocal(STORAGE_KEY));
    if (pollue && REF_INTERDITS.test(pollue)) { forgetRef(); }
    var cookieValue = normalizeRef(readCookie(COOKIE_KEY));
    if (cookieValue) return cookieValue;
    var localValue = normalizeRef(safeGetLocal(STORAGE_KEY));
    return localValue || '';
  }

  function persistRef(code) {
    if (!code) return;
    safeSetLocal(STORAGE_KEY, code);
    writeCookie(COOKIE_KEY, code, COOKIE_TTL_DAYS);
  }

  // REF_PATTERN ne valide que la FORME. Sans verification d'existence, n'importe
  // quel `?ref=` d'un tiers est capture et finit sur la commande : la commande
  // #1144 portait "Peptik Referral = inline", valeur emise par un widget externe
  // (Loox construit ses liens avec `&ref=<placement>`). Aucun coach ne s'appelle
  // ainsi, donc rien n'a ete credite, mais l'attribut polluait la commande et
  // aurait pu ecraser une vraie attribution.
  // On demande donc a peptikelite si le code existe AVANT de le persister.
  var VALIDATE_URL = 'https://peptikelite.com/api/peptik/coach-code?code=';
  function isKnownCoachCode(code) {
    return fetch(VALIDATE_URL + encodeURIComponent(code), { mode: 'cors' })
      .then(function (r) {
        if (r.status === 404) return false;      // repondu, code inconnu
        if (!r.ok) return null;                  // indisponible : on ne tranche pas
        // Contrat reel de /api/peptik/coach-code : { valid: true, code, coachFirstName }
        // ou 404 { valid: false, error }.
        return r.json().then(function (j) {
          return j && typeof j.valid === 'boolean' ? j.valid : null;
        }).catch(function () { return null; });
      })
      .catch(function () { return null; });      // reseau HS : on ne tranche pas
  }

  // Valeurs qui ne peuvent PAS etre un code coach : ce sont des placements de widgets
  // tiers. Loox construit ses liens avec `&ref=<placement>` — d'ou "inline", "loox-pr",
  // "loox-wr-btn" retrouves sur de vraies commandes. Rejet immediat, sans reseau.
  var REF_INTERDITS = /^(inline|loox[-_].*|yotpo[-_].*|judgeme[-_].*|widget|popup|banner|footer|header|sidebar|carousel|slider|modal|email|newsletter)$/i;

  function refPlausible(code) {
    if (!code) return false;
    if (REF_INTERDITS.test(code)) return false;
    return true;
  }

  function captureFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = normalizeRef(params.get('ref') || '');
      if (!fromUrl) return '';
      // Un code non plausible n'entre JAMAIS, meme temporairement.
      if (!refPlausible(fromUrl)) return '';
      // Et on ne persiste plus AVANT la reponse de peptikelite : l'ancienne version
      // ecrivait d'abord puis retirait, si bien qu'un ajout au panier pendant
      // l'aller-retour figeait un faux code sur la commande (#1236 = "inline").
      // L'attente est de l'ordre de la centaine de millisecondes, sans effet sur le
      // parcours ; en cas d'indisponibilite du service on garde le code (null), pour
      // ne pas perdre une vraie attribution a cause d'une panne reseau.
      isKnownCoachCode(fromUrl).then(function (known) {
        if (known === false) return;
        persistRef(fromUrl);
        // La remise ne part QU'ICI, apres validation. Auparavant elle etait declenchee
        // sur la simple presence d'un `?ref=` : n'importe quel lien, y compris ceux des
        // widgets Loox en `?ref=inline`, offrait 10 % sans qu'aucun coach soit implique.
        // Elle passe AVANT le marquage du panier : ce dernier fait un aller-retour reseau
        // et son echec ne doit pas priver un vrai coach de la remise. Apres le bounce
        // /discount/, le script se relance et re-stampe le panier depuis le stockage.
        try { maybeApplyDiscount(fromUrl); } catch (_) { /* la remise ne bloque jamais */ }
        applyRefToCart(fromUrl, true);
      });
      return '';
    } catch (_) { /* ignore */ }
    return '';
  }

  function forgetRef() {
    try { if (window.localStorage) localStorage.removeItem(STORAGE_KEY); } catch (_) {}
    writeCookie(COOKIE_KEY, '', -1);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function applyRefToCart(code, force) {
    // code === '' + force => on EFFACE l'attribut (code invalide detecte apres coup).
    if (!code && !force) return Promise.resolve(false);
    return fetchCart().then(function (cart) {
      if (!cart) return false;
      var existing = (cart.attributes && cart.attributes[CART_ATTR_NAME]) || '';
      if (!force && existing && existing.toUpperCase() === code) {
        return false;
      }
      var payload = { attributes: {} };
      payload.attributes[CART_ATTR_NAME] = code;
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    });
  }

  // Initial capture: URL param wins over previously stored value (so a fresh
  // share link from a partner always re-attributes the visit).
  var urlCode = captureFromUrl();
  var currentCode = urlCode || readStoredRef();

  // Stamp the cart immediately on every page load so even silently-cached
  // carts pick up the latest ref before the user adds anything.
  if (currentCode) {
    applyRefToCart(currentCode, false);
  }

  // Auto-apply the 10% coach-referral discount. We use ONE shared Shopify
  // discount code (COACH10) for every coach link — no per-coach codes to
  // maintain. The coach who EARNED the visit is attributed separately via
  // the `Peptik Referral` cart attribute (stamped above), which the order
  // webhook reads to credit the right coach. So:
  //   - Discount code in Shopify: ONE rule, 10% off, code = COACH10.
  //   - Coach attribution: per-coach, via cart attribute, independent of the
  //     discount code. Lifetime first-touch rule still wins.
  // Result: a single Shopify discount code covers every current + future
  // coach forever; nothing to create on partner approval.
  var SHARED_DISCOUNT_CODE = 'COACH10';
  // Partner share links excluded from the auto-applied 10% client discount
  // (COACH10). These partners are still tracked for attribution via the cart
  // attribute stamped above — only the client-facing discount is suppressed.
  // Codes are compared lowercase. Big Cheese, 2026-07-14: Kreate Agency (KREATEAG).
  var NO_DISCOUNT_REFS = ['kreateag'];
  function maybeApplyDiscount(refCode) {
    if (!refCode) return; // only fire when a coach link brought the visitor
    if (NO_DISCOUNT_REFS.indexOf(String(refCode).toLowerCase()) !== -1) return; // excluded partner
    var DISCOUNT_FLAG = 'peptik_coach10_applied';
    try {
      if (sessionStorage.getItem(DISCOUNT_FLAG) === '1') return;
    } catch (_) {}
    // Avoid bouncing if we're already on a /discount/ path (Shopify itself
    // serves /discount/ then 302s; this script runs on the destination).
    if ((window.location.pathname || '').toLowerCase().indexOf('/discount/') === 0) {
      try { sessionStorage.setItem(DISCOUNT_FLAG, '1'); } catch (_) {}
      return;
    }
    // Build redirect target = current path minus ?ref (other params kept).
    var url = new URL(window.location.href);
    url.searchParams.delete('ref');
    var target = url.pathname + (url.search ? url.search : '') + (url.hash || '');
    if (!target) target = '/';
    try { sessionStorage.setItem(DISCOUNT_FLAG, '1'); } catch (_) {}
    // location.replace so the discount bounce doesn't pollute back history.
    window.location.replace('/discount/' + encodeURIComponent(SHARED_DISCOUNT_CODE) + '?redirect=' + encodeURIComponent(target));
  }
  // Only auto-apply when we just got the ref from a URL (a fresh click from
  // a coach's share). Stored-only refs shouldn't keep redirecting on every
  // page load — handled by the original visit's /discount/ bounce.
  // urlCode est vide par construction : la remise est desormais declenchee dans le
  // rappel de validation ci-dessus, jamais sur la seule presence du parametre.
  if (urlCode) {
    maybeApplyDiscount(urlCode);
  }

  // Re-stamp the cart on the theme's cart-update event (fired by product forms,
  // sticky ATC, cart drawer qty changes, etc.) so the attribute survives every
  // cart transition until checkout.
  document.addEventListener('cart:update', function () {
    var code = readStoredRef();
    if (code) applyRefToCart(code, false);
  });

  // Belt-and-braces: also listen for native add-to-cart form submissions in
  // case a section dispatches a different event (legacy themes, custom forms).
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/cart/add') === -1) return;
    var code = readStoredRef();
    if (!code) return;
    // Fire-and-forget; do not block the submit. The theme already redirects
    // via fetch — the cart update will land right after the line item is added.
    setTimeout(function () { applyRefToCart(code, false); }, 250);
  }, true);
})();

